<template>
    <div class="technical-info">
        <div class="content-layout">
            <div class="column column__medium">
                <div class="block">
                    <div class="title">
                        Motor
                    </div>
                    <div class="body">
                        <line-data title="Mærkning" :value="$store.state.carData.general.MotorMaerkning" />
                        <line-data title="Drivkraft" :value="$store.state.carData.general.DrivkraftTypeNavn" />
                        <line-data title="Brændstofforbrug" :value="$store.state.carData.general.MotorKmPerLiter" suffix="km/l" />
                        <line-data title="Elektrisk forbrug" :value="$store.state.carData.general.MotorElektriskForbrug" suffix="km/l" />
                        <line-data title="Max hastighed" :value="$store.state.carData.general.MaksimumHastighed" suffix="km/t" />
                        <line-data title="Slagvolumen" :value="$store.state.carData.general.MotorSlagVolumen" suffix="cm<sup>3</sup>">
                            <span slot="extra" v-if="$store.state.carData.general.MotorStoerrelse">
                                ({{ $store.state.carData.general.MotorStoerrelse }}L)
                            </span>
                        </line-data>
                        <line-data title="Største effekt" :value="$store.state.carData.general.MotorStoersteEffekt" suffix="kW">
                            <span slot="extra">
                                (~{{ $store.state.carData.general.MotorStoersteEffekt * 1.3636363636 | rounded }} HK)
                            </span>
                        </line-data>
                        <line-data title="Antal cylindre" :value="$store.state.carData.general.MotorCylinderAntal" />
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Vægt
                    </div>
                    <div class="body">
                        <line-data title="Teknisk totalvægt" :value="$store.state.carData.general.TekniskTotalVaegt" suffix="kg" />
                        <line-data title="Totalvægt" :value="$store.state.carData.general.TotalVaegt" suffix="kg" />
                        <line-data title="Egenvægt" :value="$store.state.carData.general.EgenVaegt" suffix="kg" />
                        <line-data title="Køreklar vægt (min.)" :value="$store.state.carData.general.KoereklarVaegtMinimum" suffix="kg" />
                        <line-data title="Tilkoblingsmulighed" :value="$store.state.carData.general.Tilkoblingsmulighed" />
                        <line-data title="Vogntogsvægt" :value="$store.state.carData.general.VogntogVaegt" suffix="kg" />
                        <line-data title="Påhængsvogn totalvægt" :value="$store.state.carData.general.PaahaengVognTotalVaegt" suffix="kg" />
                        <line-data title="Påhængskøretøj med bremser" :value="$store.state.carData.general.TilkoblingsvaegtMedBremser" suffix="kg" />
                        <line-data title="Påhængskøretøj uden bremser" :value="$store.state.carData.general.TilkoblingsvaegtUdenBremser" suffix="kg" />
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Udstyr
                    </div>
                    <div class="body">
                        <!--{{ equipmentList }}-->
                        <div class="equipment" v-for="equipment in $store.state.carData.general.KoeretoejUdstyrSamling" v-if="$store.state.carData.general.KoeretoejUdstyrSamling.length > 0">
                            {{ equipment }}
                        </div>
                        <div v-if="$store.state.carData.general.KoeretoejUdstyrSamling.length === 0">
                            -
                        </div>
                    </div>
                </div>
            </div>
            <div class="column column__medium">
                <div class="block">
                    <div class="title">
                        Aksler
                    </div>
                    <div class="body">
                        <line-data title="Antal" :value="$store.state.carData.general.AkselAntal" />
                        <line-data title="Afstand" :value="$store.state.carData.general.AkselAfstand" suffix="mm" />
                        <line-data title="Trækkende aksler" :value="$store.state.carData.general.TraekkendeAksler" />
                        <line-data title="Største tryk" :value="$store.state.carData.general.StoersteAkselTryk" suffix="kg" />
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Karrosseri
                    </div>
                    <div class="body">
                        <line-data title="Type" :value="$store.state.carData.general.KarrosseriTypeNavn" />
                        <line-data title="Antal døre" :value="$store.state.carData.general.AntalDoere" />
                        <line-data title="Siddepladser (min.)" :value="$store.state.carData.general.SiddepladserMinimum" />
                        <line-data title="Fælge / dæk" :value="$store.state.carData.general.FaelgDaek" />
                        <line-data title="Sporvidde (forrest)" :value="$store.state.carData.general.SporviddenForrest" suffix="mm" />
                        <line-data title="Sporvidde (bagerst)" :value="$store.state.carData.general.SporviddenBagest" suffix="mm" />
                        <line-data title="Placering af stelnummer" :value="$store.state.carData.general.StelNummerAnbringelse" />
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Miljøoplysninger
                    </div>
                    <div class="body">
                        <line-data title="CO<sub>2</sub>-udslip" :value="$store.state.carData.general.MiljoeOplysningCO2Udslip" suffix="g" />
                        <line-data title="CO" :value="$store.state.carData.general.MiljoeOplysningEmissionCO" suffix="g/km" />
                        <line-data title="HC+NOX" :value="$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX" suffix="g/km" />
                        <line-data title="NOX" :value="$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX" suffix="g/km" />
                        <line-data title="Partikelfilter" :value="$store.state.carData.general.MiljoeOplysningPartikelFilter" />
                        <line-data title="Røgtæthed" :value="$store.state.carData.general.MiljoeOplysningRoegtaethed" suffix="m-1">
                            <span slot="extra" v-if="$store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal > 0">
                                v. {{ $store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal }} o/m
                            </span>
                        </line-data>
                        <line-data title="Partikler" :value="$store.state.carData.general.MiljoeOplysningPartikler" suffix="g/km" />
                        <line-data title="Kørselsstøj" :value="$store.state.carData.general.MotorKoerselStoej" suffix="dB" />
                        <line-data title="Standstøj" :value="$store.state.carData.general.MotorStandStoej" suffix="dB">
                            <span slot="extra" v-if="$store.state.carData.general.MotorStandStoejOmdrejningstal > 0">
                                v. {{ $store.state.carData.general.MotorStandStoejOmdrejningstal }} o/m
                            </span>
                        </line-data>
                        <line-data title="Euronorm" :value="$store.state.carData.general.NormTypeNavn" />
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Sikkerhed
                    </div>
                    <div class="body">
                        <div class="line">
                            <div class="line__title">
                                Euro NCAP testet
                            </div>
                            <div class="line__value">
                                <span v-if="$store.state.carData.general.NCAPTest">Ja</span>
                                <span v-else>Nej</span>
                            </div>
                        </div>
                        <div v-if="$store.state.carData.general.NCAPTest">
                            <a class="block-cta" style="font-weight:600;color:#00c3ae;" :href="'https://www.euroncap.com/en/search-results/?query=' + $store.state.carData.general.MaerkeTypeNavn + '+' + $store.state.carData.general.ModelTypeNavn" target="_blank" rel="noopener">
                                Søg efter NCAP test her
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .equipment {
        padding: 2px 5px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        display: inline-block;
        margin: 0 5px 5px 0;
    }

</style>


<script>
export default {
    computed: {
        equipmentList () {
            return this.$store.state.carData.general.KoeretoejUdstyrSamling.join(', ')
        }
    }
}
</script>



// WEBPACK FOOTER //
// technical-info.vue?1dc680a0